export enum ProjectSettingsMode {
  Properties,
  Info,
}
